import { create } from "zustand";

export type SettingsTab =
    | "ACCESS"
    | "TEMPLATES"
    | "COMMUNICATIONS"
    | "COURTS"
    | "BROWSER_ACCESS"
    | "BROWSER_USERS"
    | "LINKS"
    | "SECURITY";

type SettingsUiStore = {
    /** Вкладка настроек, на которую нужно перейти после открытия экрана «Настройки». */
    pendingTab: SettingsTab | null;
    requestNavigateToTab: (tab: SettingsTab) => void;
    clearPendingTab: () => void;
};

export const useSettingsUiStore = create<SettingsUiStore>((set) => ({
    pendingTab: null,
    requestNavigateToTab: (tab) => set({ pendingTab: tab }),
    clearPendingTab: () => set({ pendingTab: null }),
}));
